// Action types
const ACTION_TYPES = {
  SET_PREDICTION_QUESTION_ANSWER: "SET_PREDICTION_QUESTION_ANSWER",
};

const setPredictionQuestionAnswer = (data) => ({
  type: ACTION_TYPES.SET_PREDICTION_QUESTION_ANSWER,
  payload: data, // {id: question_id, option: option_index}
});

export { ACTION_TYPES, setPredictionQuestionAnswer };
